var _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#545454",
    points: "35.576,242.314 -0.503,205.197 141.687,62.6 299.497,207.467 260.663,242.314 148.244,122.648 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F3F3",
    points: "36.978,236.855 0.898,203.543 146.886,57.145 297.102,205.806 262.064,236.855 149.646,117.193 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleArrow);
export default __webpack_public_path__ + "static/media/google-arrow.d83505d1f11e0c124c6e7c28537a78e5.svg";
export { ForwardRef as ReactComponent };